import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/brand_logo.jpg';
import axios from 'axios';

// ✅ Always use same domain as Django backend
axios.defaults.baseURL = "http://127.0.0.1:8000";
axios.defaults.withCredentials = true;

const Navbar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');

  // ✅ Logout Function
  const handleLogout = async () => {
    try {
      await axios.post('/api/session/logout');
      alert('Logout Successfully');
      setIsLoggedIn(false);
      setMobileNumber('');
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  // ✅ Check Session
  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await axios.get('api/session/navbar_check');
        if (res.data.isAuthenticated) {
          setIsLoggedIn(true);
          setMobileNumber(res.data.mobileNumber || '');
        } else {
          setIsLoggedIn(false);
          setMobileNumber('');
        }
      } catch (error) {
        console.error('Session check failed:', error);
        setIsLoggedIn(false);
        setMobileNumber('');
      }
    };

    checkSession();
  }, []);

  // ✅ Dynamic Right-side Buttons
  const RightNavButtons = () => {
    if (isLoggedIn) {
      return (
        <div className="d-flex align-items-center">
          <span className="me-3 fw-bold text-primary">{mobileNumber}</span>
          <Link to="/profile" className="btn btn-primary me-2">Profile</Link>
          <button className="btn btn-danger" onClick={handleLogout}>Logout</button>
        </div>
      );
    } else {
      return (
        <div className="d-flex">
          <Link to="/login" className="btn btn-success me-2">Login</Link>
        </div>
      );
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm py-3 sticky-top">
      <div className="container">
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <img src={logo} alt="Logo" width="80" height="80" className="me-2 rounded-circle" />
          <strong>PandaSquare</strong>
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-between" id="navbarContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link to="/property_post" className="nav-link">Post Property</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact_us" className="nav-link">Contact Us</Link>
            </li>
            <li className="nav-item">
              <Link to="/subscription/basic" className="nav-link">Subscription</Link>
            </li>
            <li className="nav-item">
              <Link to="/construction/material_room" className="nav-link">Raw Material</Link>
            </li>
            <li className="nav-item">
              <Link to="/calculators" className="nav-link">Calculators</Link>
            </li>
          </ul>

          <RightNavButtons />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
